// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1j9rr","clinicsSelect":"styles_clinicsSelect__2rLci"};